import forEach from 'lodash/forEach'
import throttle from 'lodash/throttle'
import NextI18Next from 'next-i18next'

import Sentry from '@Globals/Sentry'

const defaultLanguage = 'en-GB'
const otherLanguages = [
  'ar-AE',
  'bg-BG',
  'cs-CZ',
  'da-DK',
  'de-AT',
  'de-CH',
  'de-DE',
  'el-GR',
  'en-AE',
  'en-AU',
  'en-CA',
  'en-IE',
  'en-NZ',
  'en-SG',
  'en-US',
  'en-ZA',
  'es-ES',
  'fi-FI',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-FR',
  'hu-HU',
  'it-IT',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'pl-PL',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sv-SE',
]

const missingKeys = {}

const reportedMissingKeys = {}

const reportMissingKeysthrottled = throttle(() => {
  const toBeReported = []

  forEach(missingKeys, ((value, key) => {
    if (reportedMissingKeys[key]) {
      return
    }

    reportedMissingKeys[key] = value
    toBeReported.push(key)
  }))

  if (!toBeReported.length) {
    return
  }

  if (process.env.NODE_ENV === 'production') {
    Sentry.captureEvent({
      extra: {
        translationKeys: toBeReported.join(','),
      },
      message: 'Missing Translations',
    })
    return
  }

  console.log('[Missing Translations]', toBeReported)
}, process.env.NODE_ENV === 'production' ? 5000 : 1000)

const i18next = new NextI18Next({
  defaultLanguage,
  missingKeyHandler: (lng, ns, key) => {
    if (!missingKeys[key]) {
      missingKeys[`${lng}:${ns}:${key}`] = true
    }

    reportMissingKeysthrottled()
  },
  otherLanguages,
  saveMissing: true,
})

i18next.i18n.languages = [defaultLanguage, ...otherLanguages]

export default i18next

